/**
 * @author xiaohuangmaoth
 * @description 行操作-查看
 * @Date 2020/1/20
 */
import React from "react";
//  import PropTypes from "prop-types";
import { component_tool } from "@/tool";
import { columns } from './config';

const { WizComponent, WizForm } = component_tool;

export default class LookForm extends WizComponent {
  render() {
    const { record } = this.props;
    
    const props = {
      ref: "form",
      columns: columns(record),
      record,
      preview: null,
      footer: null,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 },
      },
    };
    return <WizForm {...props} />;
  }
}
